export { c as convert, g as getClientId, u as uuid } from '../convert-e90e7924.js';

const isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
const isNode = new Function("try {return this===global;}catch(e){return false;}");
function isInNode() {
    return isNode();
}
function isInBrowser() {
    return isBrowser();
}
// TODO 这里的判断方式，不能仅仅判断是否是在 iframe 中
// 要加上在 portal 中的判断
function isInIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
function isAndroid(userAgentLowerCase) {
    return userAgentLowerCase.indexOf('android') !== -1;
}
function isIOS(userAgentLowerCase) {
    return (userAgentLowerCase.indexOf('iphone') !== -1 ||
        userAgentLowerCase.indexOf('ipad') !== -1);
}

export { isAndroid, isIOS, isInBrowser, isInIframe, isInNode };
//# sourceMappingURL=index.js.map
